import { pascalCase } from 'pascal-case';
import { type App, createApp as createVueApp, h } from 'vue';
import components from './components';
import TOC from './test-pages/toc/TOC.vue';
// import {applicationInsightsService} from 'Lib/services/applicationInsightsService';

import { createPinia } from 'pinia';

import './styles/aem-components.scss';

const appElements = Array.from(document.querySelectorAll('.aem-components-container'));
for (const el of appElements) {
	// Identify which component we should show based on the value of a "vue-page" attribute on the root DOM element
	let componentName = el.getAttribute('vue-page');

	// If local development, support falling back to identifying component by URL (e.g., /HelloWorld opens the HelloWorld component)
	if (!componentName && import.meta.env.DEV) {
		componentName = findComponentNameByPath();

		// Add a TOC component for local development
		components['Toc'] = TOC;
	}

	// Create app and add all our top-level components to it
	if (componentName) {
		createApp(componentName, el);
	}
}

export function createApp(componentName: string, element?: Element): App<Element> {
	const app = createVueApp({
		components: {
			...components
		},
		render: function () {
			return h(components[pascalCase(componentName)]);
		}
	});

	app.use(createPinia());

	if (element) {
		// Initialize Application Insights logger and hook it up to the Vue app's error handler
		// applicationInsightsService.initialize();
		// app.config.errorHandler = (err, instance, info) => {
		// 	applicationInsightsService.logError(err, {info});
		// 	// eslint-disable-next-line no-console
		// 	console.error('Vue error', err);
		// };

		// Mount element to DOM
		app.mount(element);
	}

	return app;
}

function findComponentNameByPath(): string {
	const pageName = window.location.pathname.split('/').pop();
	return !pageName ? 'toc' : `${pageName}`;
}
